import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/views/index";
import projectManagement from "./modul/project-management.js";
Vue.use(Router);

/**
 * 公共路由
 * 所有得角色权限都可以使用
 */
export const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      ...projectManagement,
      {
        path: "/system/role/auth/:id",
        component: resolve =>
          require(["@/manage/views/role/auth.vue"], resolve),
        name: "权限",
        meta: {
          title: "设置权限",
          affix: true
        }
      },
      {
        path: "/upDataPassword",
        component: resolve =>
          require(["@/views/user/upDataPassword.vue"], resolve),
        name: "account",
        meta: {
          title: "修改密码",
          affix: true
        }
      },

      {
        path: "/404",
        component: resolve => require(["@/common/views/404.vue"], resolve),
        hidden: true
      }
    ]
  },

  {
    path: "/login",
    name: "登录",
    component: () => import("@/common/views/login.vue")
  },
  {
    path: "/register",
    name: "账号注册",
    component: reslove => require(["@/common/views/register.vue"], reslove),
    hidden: true
  },
  {
    path: "/forget",
    name: "密码找回",
    component: resolve => require(["@/common/views/forget.vue"], resolve),
    hidden: true
  },

  {
    path: "/401",
    component: resolve => require(["@/common/views/401.vue"], resolve),
    hidden: true
  },
  // {
  // 	path: "/404",
  // 	component: resolve => require(["@/common/views/404.vue"], resolve),
  // 	// component: () => import("@/common/views/404.vue"),
  // 	hidden: true
  // },
  {
    path: "/result",
    name: "result",
    component: resolve => require(["@/common/views/result.vue"], resolve),
    meta: {
      title: "操作成功",
      icon: "dashboard",
      affix: true
    }
  }
];
export const asyncRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: []
  }
];

const route = new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes
});

// let router = new Router({
//   routes: baseRoute
// });

route.beforeEach((to, from, next) => {
  if (to.name) {
    document.title = to.meta.title || to.name;
  }
  next();
});

export default route;
